import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DetalleClientePaginaComponent } from './detalle-cliente-pagina.component';

const routes: Routes = [
    {
        path: '',
        component: DetalleClientePaginaComponent,
    },
    {
        path: 'cotizacion-imprimir/:id',
        loadChildren: 'app/pages/logueado/cotizaciones/imprimir-cotizacion-pagina/imprimir-cotizacion-pagina.module#ImprimirCotizacionPaginaModule'
    },
    {
        path: 'cotizacion-detalle/:id',
        loadChildren: 'app/pages/logueado/cotizaciones/detalle-cotizacion-pagina/detalle-cotizacion-pagina.module#DetalleCotizacionPaginaModule'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DetalleClientePaginaRoutingModule { }